<template>
  <div>
    <CreateAnnouncementForm />
  </div>

</template>

<script>
import CreateAnnouncementForm from '../components/CreateAnnouncementForm.vue'

export default {
  components: {
    CreateAnnouncementForm,
  },
}
</script>
